import script from "./AdvanceFilterComments.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvanceFilterComments.vue?vue&type=script&setup=true&lang=js"

import "./AdvanceFilterComments.vue?vue&type=style&index=0&id=2e21ac42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e21ac42"]])

export default __exports__